import React, { useState } from 'react';
import { Button, Popconfirm } from 'antd';

const ButtonWithConfirm = ({
  styles,
  onConfirm,
  text,
  title,
  danger = false,
  type = 'defalut'
}) => {
  const [open, setOpen] = useState(false);
  const [confirmLoading] = useState(false);

  const showPopconfirm = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Popconfirm
      title={title}
      okType="primary"
      okText="Yes"
      cancelText="No"
      open={open}
      onConfirm={onConfirm}
      okButtonProps={{ loading: confirmLoading }}
      onCancel={handleCancel}
    >
      <Button type={type} style={{ ...styles }} onClick={showPopconfirm} danger={danger}>
        {text}
      </Button>
    </Popconfirm>
  );
};

export default ButtonWithConfirm;
